import { render, staticRenderFns } from "./DisableAppsSwitcher.vue?vue&type=template&id=002f74a6&scoped=true&"
import script from "./DisableAppsSwitcher.vue?vue&type=script&lang=js&"
export * from "./DisableAppsSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./DisableAppsSwitcher.vue?vue&type=style&index=0&id=002f74a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f74a6",
  null
  
)

export default component.exports